module.exports = __webpack_public_path__ + "static/media/icomoon.4c39d6f5.eot";